// ======================================================================
// FILE:
// src/modules/expense_management/claims/components/ExpenseClaimsPagination.jsx
//
// MODULE:
// Expense Management
//
// FEATURE:
// Expense Claims Pagination
// ======================================================================

import React from "react";

export default function ExpenseClaimsPagination({

  page = 1,

  pageSize = 10,

  total = 0,

  onPageChange,

  onPageSizeChange,

}) {

  const totalPages = Math.max(
    1,
    Math.ceil(total / pageSize)
  );

  return (

    <div
      className="
        card-footer
        d-flex
        justify-content-between
        align-items-center
      "
    >

      {/* ====================================================== */}
      {/* RECORD COUNT */}
      {/* ====================================================== */}

      <div>

        Total Records :

        {" "}

        <strong>

          {total}

        </strong>

      </div>

      {/* ====================================================== */}
      {/* PAGE SIZE */}
      {/* ====================================================== */}

      <div
        className="
          d-flex
          align-items-center
          gap-2
        "
      >

        <label className="mb-0">

          Rows

        </label>

        <select

          className="form-select"

          style={{
            width: 90,
          }}

          value={pageSize}

          onChange={(e) =>
            onPageSizeChange(
              Number(e.target.value)
            )
          }

        >

          <option value={10}>
            10
          </option>

          <option value={20}>
            20
          </option>

          <option value={50}>
            50
          </option>

          <option value={100}>
            100
          </option>

        </select>

      </div>

      {/* ====================================================== */}
      {/* PAGINATION */}
      {/* ====================================================== */}

      <div
        className="
          d-flex
          align-items-center
        "
      >

        <button

          className="
            btn
            btn-outline-secondary
            btn-sm
            me-2
          "

          disabled={
            page <= 1
          }

          onClick={() =>
            onPageChange(page - 1)
          }

        >

          Previous

        </button>

        <span>

          Page

          {" "}

          <strong>

            {page}

          </strong>

          {" "}

          of

          {" "}

          <strong>

            {totalPages}

          </strong>

        </span>

        <button

          className="
            btn
            btn-outline-secondary
            btn-sm
            ms-2
          "

          disabled={
            page >= totalPages
          }

          onClick={() =>
            onPageChange(page + 1)
          }

        >

          Next

        </button>

      </div>

    </div>

  );

}